
import React from "react";
import { Editor } from "@tiptap/react";
import VideoDialog from "../dialogs/VideoDialog";
import ImageDialog from "../dialogs/ImageDialog";
import GalleryDialog from "../dialogs/GalleryDialog";

interface MediaDialogsProps {
  editor: Editor;
  uploadImage?: (file: File) => Promise<string>;
  imagePopoverOpen: boolean;
  setImagePopoverOpen: (open: boolean) => void;
  videoPopoverOpen: boolean;
  setVideoPopoverOpen: (open: boolean) => void;
  galleryPopoverOpen: boolean;
  setGalleryPopoverOpen: (open: boolean) => void;
  mediaLibraryOpen: boolean;
  setMediaLibraryOpen: (open: boolean) => void;
  handleMediaSelect: (url: string) => void;
}

const MediaDialogs = ({
  editor,
  uploadImage,
  imagePopoverOpen,
  setImagePopoverOpen,
  videoPopoverOpen,
  setVideoPopoverOpen,
  galleryPopoverOpen,
  setGalleryPopoverOpen,
  mediaLibraryOpen,
  setMediaLibraryOpen,
  handleMediaSelect,
}: MediaDialogsProps) => {
  return (
    <>
      {/* Video Dialog */}
      <VideoDialog 
        editor={editor}
        isOpen={videoPopoverOpen}
        setIsOpen={setVideoPopoverOpen}
      />

      {/* Image Dialog */}
      <ImageDialog 
        editor={editor}
        uploadImage={uploadImage}
        isOpen={imagePopoverOpen}
        setIsOpen={setImagePopoverOpen}
      />

      {/* Gallery Dialog */}
      <GalleryDialog 
        editor={editor}
        uploadImage={uploadImage}
        isOpen={galleryPopoverOpen}
        setIsOpen={setGalleryPopoverOpen}
      />
    </>
  );
};

export default MediaDialogs;
